import {
  type SortableListViewProps,
  type SortingStrategyEnum,
} from './types.js';
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  MeasuringStrategy,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToVerticalAxis as restrictToVerticalAxisModifier } from '@dnd-kit/modifiers';
import {
  horizontalListSortingStrategy,
  rectSortingStrategy,
  SortableContext,
  sortableKeyboardCoordinates,
  type SortingStrategy,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

const sortStrategyMap: { [key in SortingStrategyEnum]: SortingStrategy } = {
  GRID: rectSortingStrategy,
  HORIZONTAL_LIST: horizontalListSortingStrategy,
  VERTICAL_LIST: verticalListSortingStrategy,
};

export const SortableListView = ({
  children,
  restrictToVerticalAxis,
  sortedNodeIds,
  sortListeners,
  sortStrategy = 'GRID',
}: SortableListViewProps) => {
  const sensors = useSensors(
    useSensor(TouchSensor),
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <DndContext
      collisionDetection={closestCenter}
      measuring={{ droppable: { strategy: MeasuringStrategy.Always } }}
      modifiers={
        restrictToVerticalAxis ? [restrictToVerticalAxisModifier] : undefined
      }
      sensors={sensors}
      {...sortListeners}
    >
      <SortableContext
        items={sortedNodeIds}
        strategy={sortStrategyMap[sortStrategy]}
      >
        {children}
      </SortableContext>
    </DndContext>
  );
};
